import React, { useState, useEffect } from 'react'
import Title from './Title';
import { Table, TableHead, TableRow, TableCell, TableBody, Button, Grid, makeStyles, CircularProgress, Typography} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import {history, MyMess} from '../../App'
import { useSelector } from 'react-redux';
import { GlobalSnackBarUtil } from '../../component/GlobalSnackBar';
import { GetDomains } from '../../server/WebServiceUrl';
import Axios from 'axios';
import format from 'date-fns/format';
import AssignDomainDialog from './AssignDomainDialog';
import CachedIcon from '@material-ui/icons/Cached';
import AddIcon from '@material-ui/icons/Add';
import LinkIcon from '@material-ui/icons/Link';
import {GreenButton} from '../../component/colorButton';
const useStyles = makeStyles((theme) => ({
  btn: {
    '&:first-of-type': {
      marginRight: '3px',
    },
    marginBottom: '3px',
  },
  spinner: {
    margin: 10
  },
  paper: {
    width: '80%',
    maxHeight: 435,
  },
  tableAppBar: {
    '& > *':{
      marginLeft: theme.spacing(1)
    }
  }
}));

export default function Domains() {  
  
  const classes = useStyles();
  const user = useSelector(state => state.user);
  const [domains, setDomains] = useState([]);
  const [selectedDomain, setSelectedDomain] = useState({});
  const [isFetching, setFetching] = useState(false);
  const [open, setOpen] = useState(false);

  const handleClickAssign = (e, item) => {
    setSelectedDomain(item);
    setOpen(true);
  };

  const handleClose = (updated) => {
    setOpen(false);
    if (updated) {
      runRefresh()
    }
  };

  useEffect(()=> {

    if(user.authorization){
      runRefresh()
    }

    return ;
  },[])


  const refreshHandler = (e) => {
    if(user.authorization){
      runRefresh()
    }
  }

  const runRefresh =async () => {
    setFetching(true);
    let res = await Axios.get(GetDomains);
    if(res && res.status === 200 && res.data && res.data.domains){
      setDomains(res.data.domains);
    } else {
      GlobalSnackBarUtil.open({
        message:MyMess.refreshFail,
        severity:'error'
      })
    }
    setFetching(false);
  }

  const renderBooleanValue = (value) => {
    if (value) {
      return (
        <CheckIcon color="primary" />
      )
    }

    return  <CloseIcon />;
  }

  const formatDate = (value) => {
    if (value) {
      return format(new Date(value), "yyyy-MM-dd")
    }

    return "";
  }

  const renderTableBody =() => {

    if (isFetching) {
      return (
        <TableBody>
          <TableRow>
            <TableCell align='center' colSpan={7}>
                <CircularProgress className={classes.spinner} size={36} thickness={4} />
              </TableCell>
          </TableRow>
        </TableBody>
      )
    }

    if(domains && domains.length > 0) {
      return (
        <TableBody>
          {domains.map((item) => (
          <TableRow style={{height: 52}} key={item.id}>
            <TableCell >{item.domain}</TableCell>
            <TableCell>{formatDate(item.createdAt) }</TableCell>
            <TableCell>{formatDate(item.expireAt) }</TableCell>
            <TableCell>{MyMess.domains.statuses[item.status]}</TableCell>
            {/* <TableCell>{item.status}</TableCell> */}
            <TableCell>{item.kopapro || ''}</TableCell>
            {/* <TableCell>{item.renewDeadline}</TableCell> */}
            {/* <TableCell>{renderBooleanValue(item.renewable)}</TableCell> */}
            <TableCell>
              {
                (item.status !== 'processing') &&
                <GreenButton  className={classes.btn} onClick={ e => {handleClickAssign(e,item)}} variant="contained" color="primary" startIcon={<LinkIcon />} >{MyMess.assign}</GreenButton>
              }
              
            </TableCell>
          </TableRow>
        ))}
        </TableBody>
      )

    } else {
      return (
        <TableBody>
          <TableRow>
            <TableCell align='center' colSpan={7}>
              <Typography variant="subtitle1">{MyMess.general.noRecord}</Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      )
    }
  }

  return (
    <React.Fragment>
      <Grid container={true} justify="space-between">
        <Grid item xs={6}>
          <Title>{MyMess.domains.title}</Title>
        </Grid>  
        <Grid container justify="flex-end" className={classes.tableAppBar} >

          <Button variant="contained" color="primary" onClick={refreshHandler} startIcon={<CachedIcon />} >
              {MyMess.refresh}
          </Button>
          <Button variant="contained" color="primary" onClick={e => {history.push('/main/domains/create')}} startIcon={<AddIcon />} >
              {MyMess.addNewDomain}
          </Button>
        </Grid>
      </Grid>      
      

      <Table size="small">
      <caption>{MyMess.domains.delayRecords}</caption>
        <TableHead>
          <TableRow>
            <TableCell>{MyMess.domains.domainName}</TableCell>
            <TableCell>{MyMess.domains.createAt}</TableCell>
            <TableCell>{MyMess.domains.expires}</TableCell>
            <TableCell>{MyMess.domains.status}</TableCell>
            <TableCell>{MyMess.domains.mappedKopaPro}</TableCell>
            {/* <TableCell>{MyMess.domains.renewDeadline}</TableCell> */}
            {/* <TableCell>{MyMess.domains.renewable}</TableCell> */}
            <TableCell align="right"></TableCell>
          </TableRow>
        </TableHead>
        {renderTableBody()}
      </Table>
      <AssignDomainDialog
          classes={{
            paper: classes.paper,
          }}
          id="ringtone-menu"
          keepMounted
          open={open}
          onClose={handleClose}
          value={selectedDomain.kopapro || ''}
          domain={selectedDomain.domain || ''}
          domainId={selectedDomain.uuid || ''}
        />      
    </React.Fragment>
  )
}
